import { render, staticRenderFns } from "./UpcomingPlanChanges.vue?vue&type=template&id=12ab84f0&scoped=true&"
import script from "./UpcomingPlanChanges.vue?vue&type=script&lang=js&"
export * from "./UpcomingPlanChanges.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingPlanChanges.vue?vue&type=style&index=0&id=12ab84f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab84f0",
  null
  
)

component.options.__file = "UpcomingPlanChanges.vue"
export default component.exports